import Image from "next/image";
import { memo, useEffect } from "react";

const Process = () => {
  useEffect(() => {
    (function () {
      "use strict";

      // define variables
      const items = document.querySelectorAll(".timeline li");

      // check if an element is in viewport
      function isElementInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
      }
      function callbackFunction() {
        for (const item of items) {
          if (isElementInViewport(item)) {
            item.classList.add("in-view");
          }
        }
      }
      // listen for events
      window.addEventListener("load", callbackFunction);
      window.addEventListener("resize", callbackFunction);
      window.addEventListener("scroll", callbackFunction);
    })();
  }, []);

  return (
    <>
      <div className="pt-6">
        <h2 className="text-4xl text-black text-center font-medium">
          Our Consultation Approach
        </h2>
      </div>
      <section className="timeline overflow-hidden">
        <ul className="pt-12 xl:py-12">
          <li className="list-none relative w-0.5 ml-5 lg:mx-auto pt-12 bg-black after:absolute after:left-1/2 after:bottom-0 after:top-0 after:-translate-x-1/2 after:w-4 after:h-4 after:rounded-full after:bg-inherit after:transition-colors after:duration-500 after:ease-in-out">
            <div className="relative bottom-4 w-full p-8 border-none rounded-2xl card bg-[#f9f6ff] transition-all duration-500 ease-in-out">
              <time className="flex justify-between items-end mb-2">
                <span className="text-xl md:text-3xl text-[#8a4bed]">
                  Learn
                </span>
                <div>
                  <Image
                    alt="Learn"
                    height={40}
                    src="/assets/services/it-consulting/mind.webp"
                    title="Learn"
                    width={40}
                  />
                </div>
              </time>
              <div className="flex flex-col">
                <span className="text-base font-normal mb-2">
                  1 Project Status
                </span>
                <span className="text-base font-normal mb-2">
                  2 Current Team
                </span>
                <span className="text-base font-normal mb-2">
                  3 Project Deliverable
                </span>
                <span className="text-base font-normal mb-2">
                  4 Key Performance Indicators
                </span>
              </div>
            </div>
          </li>
          <li className="list-none relative w-0.5 ml-5 lg:mx-auto pt-12 bg-black after:absolute after:left-1/2 after:bottom-0 after:top-0 after:-translate-x-1/2 after:w-4 after:h-4 after:rounded-full after:bg-inherit after:transition-colors after:duration-500 after:ease-in-out">
            <div className="relative bottom-4 w-full p-8 border-none rounded-2xl card bg-[#fcf6ff] transition-all duration-500 ease-in-out">
              <time className="flex justify-between items-end mb-2">
                <span className="text-xl md:text-3xl text-[#ec76ab]">
                  Identify
                </span>
                <div>
                  <Image
                    alt="Identify"
                    height={40}
                    src="/assets/services/it-consulting/search.webp"
                    title="Identify"
                    width={40}
                  />
                </div>
              </time>
              <div className="flex flex-col">
                <span className="text-base font-normal mb-2">
                  1 Product Requirement
                </span>
                <span className="text-base font-normal mb-2">
                  2 Business Objectives
                </span>
                <span className="text-base font-normal mb-2">
                  3 Success Attributes
                </span>
                <span className="text-base font-normal mb-2">4 Blockers </span>
              </div>
            </div>
          </li>
          <li className="list-none relative w-0.5 ml-5 lg:mx-auto pt-12 bg-black after:absolute after:left-1/2 after:bottom-0 after:top-0 after:-translate-x-1/2 after:w-4 after:h-4 after:rounded-full after:bg-inherit after:transition-colors after:duration-500 after:ease-in-out">
            <div className="relative bottom-4 w-full p-8 border-none rounded-2xl card bg-[#f4fffd] transition-all duration-500 ease-in-out">
              <time className="flex justify-between items-end mb-2">
                <span className="text-xl md:text-3xl text-[#60d3be]">
                  Review
                </span>
                <div>
                  <Image
                    alt="Review"
                    height={40}
                    src="/assets/services/it-consulting/target.webp"
                    title="Review"
                    width={40}
                  />
                </div>
              </time>
              <div className="flex flex-col">
                <span className="text-base font-normal mb-2">
                  1 Architecture
                </span>
                <span className="text-base font-normal mb-2">2 Code</span>
                <span className="text-base font-normal mb-2">3 Security </span>
                <span className="text-base font-normal mb-2">
                  4 Product analysis
                </span>
              </div>
            </div>
          </li>
          <li className="list-none relative w-0.5 ml-5 lg:mx-auto pt-12 bg-black after:absolute after:left-1/2 after:bottom-0 after:top-0 after:-translate-x-1/2 after:w-4 after:h-4 after:rounded-full after:bg-inherit after:transition-colors after:duration-500 after:ease-in-out">
            <div className="relative bottom-4 w-full p-8 border-none rounded-2xl card bg-[#f5fbff] transition-all duration-500 ease-in-out">
              <time className="flex justify-between items-end mb-2">
                <span className="text-xl md:text-3xl text-[#529fea]">
                  Approach
                </span>
                <div>
                  <Image
                    alt="Approach"
                    height={40}
                    src="/assets/services/it-consulting/approach.webp"
                    title="Approach"
                    width={40}
                  />
                </div>
              </time>
              <div className="flex flex-col">
                <span className="text-base font-normal mb-2">
                  1 Team formation
                </span>
                <span className="text-base font-normal mb-2">
                  2 Code refactoring
                </span>
                <span className="text-base font-normal mb-2">
                  3 Product improvements
                </span>
                <span className="text-base font-normal mb-2">
                  4 Risk mitigation
                </span>
              </div>
            </div>
          </li>
          <li className="list-none relative w-0.5 ml-5 lg:mx-auto pt-12 bg-black after:absolute after:left-1/2 after:bottom-0 after:top-0 after:-translate-x-1/2 after:w-4 after:h-4 after:rounded-full after:bg-inherit after:transition-colors after:duration-500 after:ease-in-out"></li>
          <div className="relative top-10 xl:-top-32 bg-white w-52 xl:w-[12rem] h-16 rotate-90 mx-auto -left-40 md:-left-96 xl:left-auto"></div>
        </ul>
      </section>
    </>
  );
};

export default memo(Process);
